import { Slide } from 'interfaces/slide';
import React, { FunctionComponent } from 'react';
import { getSlideThumbnailUrl } from 'utils/helpers';
import { useLabs } from 'utils/queryHooks/useLabs';
import ImageWithFallback from '../../ImageWithFallback';

interface Props {
  slide: Slide;
}

const SlideThumbnailImage: FunctionComponent<Props> = ({ slide }) => {
  const { data: labs = [] } = useLabs();
  const isStagingLab = Boolean(labs.find((lab) => lab.id === slide.labId)?.isStagingLab);
  const thumbnailUrl = getSlideThumbnailUrl(slide, { isStagingLab });
  return <ImageWithFallback imageUrls={[thumbnailUrl]} slide={slide} />;
};

export default SlideThumbnailImage;
